<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11xeLQm/tc-custom/9781625844149.jpg?1736609289628" alt="This image is the cover for the book Ghost Stories of St. Petersburg, Clearwater and Pinellas County"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghost Stories of St. Petersburg, Clearwater and Pinellas County
      </h1>
      <p class="bookDescription body article font2">
        <b>Some parts of sunny Florida can be downright chilling . . . A haunting historical tour with photos included!</b><br/>  <br/> Does the restless ghost of a murder victim haunt a Gulfport home? Does a doomed pirate search for his lost treasure at John’s Pass? Are sea captains and Civil War soldiers still combing the area, years after their deaths?<br/>  <br/> With wit and style, the “Queen of Haunts,” Deborah Frethem, calls upon years of experience as the general manager and guide of Tampa Bay Ghost Tours to present legends of sinister deeds and whispers of the past from Florida’s haunted peninsula.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Frethem
      </h2>
      
      <p class="authorDescription body article">Deborah Frethem researches, writes, and tells ghost stories. She previously published <I>Ghost Stories of St. Petersburg, Clearwater, and Pinellas County</I> with The History Press in 2007.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45acb6f6